<template>
  <nav v-if="chatScopes.length > 1" class="messages__chat_scope_switcher" :aria-label="navigationLabel">
    <span id="inbox_header" class="sr_only">
      {{ i18n.$gettext('%{title} inbox', { title: title(currentChatScope) }) }}"
    </span>
    <button
      id="messages__chat_scope_switcher__toggle_button"
      type="button"
      class="button button--cta_secondary button--small messages__chat_scope_switcher__toggle_button"
      aria-controls="messages__chat_scope_switcher__list"
      :aria-expanded="String(expanded)"
      @click="toggle"
    >
      <span class="sr_only"> {{ i18n.$gettext('Change inbox') }} </span>
      <img
        :title="title(currentChatScope)"
        :src="imageURL(currentChatScope)"
        alt=""
        aria-hidden="true"
        class="messages__chat_scope_switcher__image"
      />
      <svg width="16" height="10" viewBox="0 0 16 10" fill="none" class="messages__chat_scope_switcher__dropdown">
        <path
          d="M14.4742 0L8 6.47424L1.52576 0L0 1.52576L7.23712 8.76288C7.43947 8.96517 7.71388 9.07881 8 9.07881C8.28612 9.07881 8.56053 8.96517 8.76288 8.76288L16 1.52576L14.4742 0Z"
          fill="#D0CFE6"
        />
      </svg>
    </button>
    <transition name="messages__chat_scope_switcher__list_wrapper--slide">
      <div v-show="expanded" ref="listWrapper" class="messages__chat_scope_switcher__list_wrapper">
        <ul class="messages__chat_scope_switcher__list">
          <li v-for="chatScope in chatScopes" :key="chatScope.path">
            <router-link
              :to="chatScopePath(chatScope.path)"
              :class="{
                messages__chat_scope_switcher__link: true,
                'messages__chat_scope_switcher__link--current': chatScope.path === currentChatScope.path
              }"
            >
              <div class="messages__chat_scope_switcher__list_item">
                <div class="messages__chat_scope_switcher__list_item__text">
                  <div class="messages__chat_scope_switcher__list_item__title">
                    {{ title(chatScope) }}
                  </div>
                  <div class="messages__chat_scope_switcher__list_item__subtitle">
                    {{ subtitle(chatScope) }}
                  </div>
                </div>

                <div class="messages__chat_scope_switcher__list_item__image_and_count_unread">
                  <div v-if="chatScope.count_unread > 0" class="messages__chat_scope_switcher__list_item__count_unread">
                    <span aria-hidden="true">{{ chatScope.count_unread }}</span>

                    <span class="sr_only">
                      {{
                        i18n.$ngettext('%{count} unread message', '%{count} unread messages', chatScope.count_unread, {
                          count: chatScope.count_unread
                        })
                      }}
                    </span>
                  </div>
                  <img
                    :src="imageURL(chatScope)"
                    alt=""
                    aria-hidden="true"
                    class="messages__chat_scope_switcher__list_item__image"
                  />
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { chatScopePath, MEMBER_CHAT_SCOPE } from './route_helpers'

export default {
  name: 'ChatScopeSwitcher',
  data: () => {
    return { expanded: false }
  },
  computed: {
    ...mapGetters({
      chatScopes: 'getChatScopes'
    }),
    currentChatScope() {
      return this.$store.getters.getChatScopeByPath(this.$route.params.chatScope)
    },
    navigationLabel() {
      return this.i18n.$gettext('Messages')
    }
  },
  mounted() {
    document.body.addEventListener('click', this.maybeHide)
  },
  beforeUnmount() {
    document.body.removeEventListener('click', this.maybeHide)
  },
  methods: {
    chatScopePath,
    title(chatScope) {
      if (chatScope.path === MEMBER_CHAT_SCOPE) {
        if (chatScope.user.last_name) {
          return `${chatScope.user.first_name} ${chatScope.user.last_name}`
        } else {
          return chatScope.user.first_name
        }
      } else {
        return chatScope.publication.title
      }
    },
    subtitle(chatScope) {
      if (chatScope.path === MEMBER_CHAT_SCOPE) {
        return chatScope.user.email
      } else {
        return null
      }
    },
    imageURL(chatScope) {
      if (chatScope.path === MEMBER_CHAT_SCOPE) {
        return chatScope.user.avatar_url
      } else {
        return chatScope.publication.logo_url
      }
    },
    toggle() {
      if (this.expanded) {
        this.hide()
      } else {
        this.show()
      }
    },
    show() {
      this.expanded = true
    },
    hide() {
      this.expanded = false
    },
    maybeHide(event) {
      if (this.expanded && !event.target.closest('#messages__chat_scope_switcher__toggle_button')) {
        this.hide()
      }
    }
  }
}
</script>
